// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/20261012084031/css/" + chunkId + "." + {"132":"c84d8fe7","190":"d66b8de1","206":"35358ffc","255":"260d4a36","856":"c3a32b2a"}[chunkId] + ".css";
};